const LikeIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5001 21V11.1L11.1001 3C12.5913 3 13.8001 4.20883 13.8001 5.70002V9.30001H19.2001C19.7282 9.29401 20.2323 9.52026 20.5788 9.91876C20.9253 10.3173 21.0793 10.8479 21.0001 11.37L19.7581 19.47C19.6236 20.3575 18.8556 21.0102 17.9581 21H7.5001ZM7.5001 21L5.097 20.9998C4.04266 21.0185 3.14135 20.2448 3 19.1998V12.8998C3.14135 11.8549 4.04266 10.9815 5.097 11.0002H7.5L7.5001 21Z"
        stroke="#090914"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LikeIcon;
